<div *ngIf="selectedPolicy || (policies && policies.length > 1)">
	<mat-label class="title d-block mt-0 mt-md-5 mb-4">{{ 'contactDetails.title' | translate }}</mat-label>
	<p class="subtitle">{{ 'contactDetails.primaryData.title' | translate }}</p>

	<form [formGroup]="form">
		<!-- Si hay sólo una póliza -->
		<div class="row" *ngIf="policies && policies.length === 1">
			<div class="col-12 p-0" formGroupName="primaryData">
				<p class="title-data fw-medium m-0 mb-2">{{ 'contactDetails.primaryData.policyId' | translate }}</p>
				<span class="value-data fs-6 m-0">{{ form.get('primaryData')?.get('policyId')?.value }}</span>

				<p class="title-data fw-medium m-0 mb-2">{{ 'contactDetails.primaryData.nameSurname' | translate }}</p>
				<span class="value-data fs-6 m-0">{{ form.get('primaryData')?.get('clientName')?.value }}</span>

				<p class="title-data fw-medium m-0 mb-2">{{ 'contactDetails.primaryData.address' | translate }}</p>
				<span class="value-data fs-6 m-0">{{ form.get('primaryData')?.get('address')?.value }}</span>
			</div>
		</div>
		<!-- FIN Si hay sólo una póliza -->

		<!-- Si hay más de una póliza -->
		<div class="row" *ngIf="policies && policies.length > 1">
			<div class="col-12 p-0">
				<p class="fw-bold mb-2">
					{{ 'contactDetails.primaryData.selectPolicy' | translate }}
				</p>
				<table class="table p-0">
					<thead>
						<tr>
							<th scope="col"></th>
							<th scope="col">{{ 'contactDetails.primaryData.nameSurname' | translate }}</th>
							<th scope="col">{{ 'contactDetails.primaryData.address' | translate }}</th>
							<th scope="col">{{ 'contactDetails.primaryData.policyId' | translate }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let policy of policies">
							<th scope="row">
								<input
									class="form-check-input"
									type="radio"
									(click)="onSelectPolicy(policy)"
									[checked]="policy === selectedPolicy"
								/>
							</th>
							<td>{{ policy.name }} {{ policy.surname }} {{ policy.secondSurname }}</td>
							<td>{{ policy.adressInfo.adress }}</td>
							<td>{{ policy.policy }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- FIN Si hay más de una póliza -->

		<div class="row" formGroupName="primaryData" *ngIf="selectedPolicy">
			<div class="col-12 p-0 mt-4">
				<p class="fw-bold mb-2">{{ 'contactDetails.primaryData.rightAddress' | translate }}</p>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="rightAddress"
						id="rightAddress1"
						[value]="true"
						formControlName="rightAddress"
						(click)="onChangeRightAddress()"
					/>
					<label class="form-check-label ms-2 mt-1" for="rightAddress1">{{ 'common.yes' | translate }} </label>
				</div>
				<div class="form-check mt-2">
					<input
						class="form-check-input"
						type="radio"
						name="rightAddress"
						id="rightAddress2"
						[value]="false"
						formControlName="rightAddress"
						(click)="onChangeRightAddress()"
					/>
					<label class="form-check-label ms-2 mt-1" for="rightAddress2">{{ 'common.no' | translate }} </label>
				</div>
			</div>
			<validation-messages [control]="form.get('primaryData')?.get('rightAddress')"></validation-messages>

			<div class="col-12 p-0 mt-4" *ngIf="form.get('primaryData')?.get('rightAddress')?.value === false">
				<p class="fw-bold mb-2">{{ 'contactDetails.primaryData.questionReasonWrongAddress' | translate }}</p>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="reasonWrongAddress"
						id="reasonWrongAddress1"
						value="a"
						formControlName="reasonWrongAddress"
					/>
					<label class="form-check-label ms-2 mt-1" for="reasonWrongAddress1"
						> {{ 'contactDetails.primaryData.responseReasonWrongAddressA' | translate }}
					</label>
				</div>
				<div class="form-check mt-2">
					<input
						class="form-check-input"
						type="radio"
						name="reasonWrongAddress"
						id="reasonWrongAddress2"
						value="b"
						formControlName="reasonWrongAddress"
					/>
					<label class="form-check-label ms-2 mt-1" for="reasonWrongAddress2"
						> {{ 'contactDetails.primaryData.responseReasonWrongAddressB' | translate }}
					</label>	
				</div>
			</div>
			<div class="col-12 p-0 mt-4" *ngIf="form.get('primaryData')?.get('rightAddress')?.value === true 
				|| (form.get('primaryData')?.get('rightAddress')?.value === false && form.get('primaryData')?.get('reasonWrongAddress')?.value)">
				<p class="fw-bold mb-2">{{ 'contactDetails.primaryData.homeType' | translate }}</p>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="housingType"
						id="housingType1"
						value="piso"
						formControlName="housingType"
					/>
					<label class="form-check-label ms-2 mt-1" for="housingType1"
						>{{ 'contactDetails.primaryData.flat' | translate }}
					</label>
				</div>
				<div class="form-check mt-2">
					<input
						class="form-check-input"
						type="radio"
						name="housingType"
						id="housingType2"
						value="unifamiliar"
						formControlName="housingType"
					/>
					<label class="form-check-label ms-2 mt-1" for="housingType2"
						>{{ 'contactDetails.primaryData.detached' | translate }}
					</label>
				</div>
			</div>
			<validation-messages [control]="form.get('primaryData')?.get('housingType')" *ngIf="form.get('primaryData')?.get('rightAddress')?.value !== null"></validation-messages>

			<!-- <div class="col-12 p-0 mt-4" *ngIf="form.get('primaryData')!.get('housingType')!.value">
				<p class="fw-bold mb-2">{{ 'contactDetails.primaryData.isPolicyHolder' | translate }}</p>
				<div class="form-check">
					<input
						class="form-check-input"
						type="radio"
						name="policyHolder"
						id="policyHolder1"
						[value]="true"
						formControlName="policyHolder"
						(click)="onChangePolicyHolder(true)"
					/>
					<label class="form-check-label ms-2 mt-1" for="policyHolder1"
						>{{ 'contactDetails.primaryData.yesPolicyHolder' | translate }}
					</label>
				</div>
				<div class="form-check mt-2">
					<input
						class="form-check-input"
						type="radio"
						name="policyHolder"
						id="policyHolder2"
						[value]="false"
						formControlName="policyHolder"
						(click)="onChangePolicyHolder(false)"
					/>
					<label class="form-check-label ms-2 mt-1" for="policyHolder2"
						>{{ 'contactDetails.primaryData.noPolicyHolder' | translate }}
					</label>
				</div>
			</div>
			<validation-messages [control]="form.get('primaryData')?.get('policyHolder')"></validation-messages> -->
		</div>

		<div
			class="row"
			*ngIf="
				form.get('primaryData')?.get('housingType')?.value &&
				form.get('primaryData')?.get('policyHolder')?.value === false &&
				(form.get('primaryData')?.get('rightAddress')?.value === true 
					|| (form.get('primaryData')?.get('rightAddress')?.value === false 
						&& form.get('primaryData')?.get('reasonWrongAddress')?.value)
				)"
			
			formGroupName="declarant"
		>
			<div class="col-12 p-0">
				<p class="subtitle mt-4 mb-2">{{ 'contactDetails.declarantData.title' | translate }}</p>
			</div>

			<div class="col-12 p-0">
				<div class="col col-md-6 mb-3">
					<div class="d-flex align-items-center justify-content-between">
						<label for="declarantName" class="form-label">{{ 'contactDetails.declarantData.name' | translate }}</label>
					</div>
					<input
						type="text"
						class="form-control"
						id="declarantName"
						placeholder="{{ 'contactDetails.declarantData.name' | translate }}"
						formControlName="name"
						maxlength="20"
					/>
					<validation-messages [control]="form.get('declarant')?.get('name')"></validation-messages>
				</div>
				<div class="col col-md-6 mb-3">
					<div class="d-flex align-items-center justify-content-between">
						<label for="declarantSurame" class="form-label">{{
							'contactDetails.declarantData.surname' | translate
						}}</label>
					</div>
					<input
						type="text"
						class="form-control"
						id="declarantSurame"
						placeholder="{{ 'contactDetails.declarantData.surname' | translate }}"
						formControlName="surname"
						maxlength="20"
					/>
					<validation-messages [control]="form.get('declarant')?.get('surname')"></validation-messages>
				</div>
				<div class="col col-md-6 mb-3">
					<div class="d-flex align-items-center justify-content-between">
						<label for="declarantSecondSurame" class="form-label">{{
							'contactDetails.declarantData.secondSurname' | translate
						}}</label>
						<span class="form-label-optional">{{ 'common.optional' | translate }}</span>
					</div>
					<input
						type="text"
						class="form-control"
						id="declarantSurame"
						placeholder="{{ 'contactDetails.declarantData.secondSurname' | translate }}"
						formControlName="secondSurname"
						maxlength="20"
					/>
					<validation-messages [control]="form.get('declarant')?.get('secondSurname')"></validation-messages>
				</div>
				<div class="col col-md-6 mb-3">
					<label for="declarantRelationship" class="form-label">{{
						'contactDetails.declarantData.relationship.title' | translate
					}}</label>
					<div ngbDropdown>
						<button type="button" class="btn btn-light w-100" id="dropdownBasic1" ngbDropdownToggle>
							{{
								form.get('declarant')?.get('relationship')?.value
									? form.get('declarant')?.get('relationship')?.value.description
									: ('contactDetails.declarantData.relationship.title' | translate)
							}}
						</button>
						<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
							<button
								ngbDropdownItem
								*ngFor="let relationship of declarantRelationships"
								(click)="onSelectDeclarantRelationship(relationship)"
							>
								{{ relationship.description }}
							</button>
						</div>
					</div>
					<validation-messages [control]="form.get('declarant')?.get('relationship')"></validation-messages>
				</div>
			</div>
		</div>

		<div
			class="row"
			*ngIf="form.get('primaryData')!.get('policyHolder')!.value !== (undefined || null || '') &&
			form.get('primaryData')!.get('housingType')!.value &&
			(form.get('primaryData')?.get('rightAddress')?.value === true 
					|| (form.get('primaryData')?.get('rightAddress')?.value === false 
						&& form.get('primaryData')?.get('reasonWrongAddress')?.value)
				)"
			formGroupName="contactData"
		>
			<div class="col-12 p-0">
				<p class="subtitle mt-4 mb-2">{{ 'contactDetails.contactData.title' | translate }}</p>
				<p class="mb-4">
					{{ 'contactDetails.contactData.addContactsMessage' | translate }}
				</p>

				<div class="col-12 col-md-8 mb-4 pe-2 pe-xs-0">
					<div class="d-flex align-items-center justify-content-between">
						<label for="contactEmail" class="form-label">{{ 'contactDetails.contactData.email' | translate }}</label>
						<span *ngIf="this.typePrimaryPhoneSelect === '2' && !this.contactByEmail" class="form-label-optional">{{ 'common.optional' | translate }}</span>
					</div>
					<input
						type="text"
						class="form-control"
						id="contactEmail"
						placeholder="{{ 'contactDetails.contactData.email' | translate }}"
						formControlName="email"
						maxlength="90"
						(focus)="handleInputEmailFocus(true)"
						(blur)="handleInputEmailFocus(false)"
					/>
					<div class="text-danger" *ngIf="contactByEmail && !sessionData.contactData?.email.length && !focusAndDeleteAlertEmail">{{ 'validationMessages.required' | translate }}</div>
					<validation-messages [control]="form.get('contactData')?.get('email')"></validation-messages>
				</div>

				<div formArrayName="contacts">
					<div *ngFor="let contact of contacts.controls; let i = index">
						<div class="row mb-4" [formGroupName]="i">
							<div class="col-12 col-md-8 col-lg-4 ps-0 pe-xs-0">
								<label for="exampleFormControlInput1" class="form-label">{{ 'common.phone' | translate }}</label>
								<div class="input-group">
									<div ngbDropdown>
										<button
											type="button"
											class="btn btn-light rounded-0 rounded-start w-100"
											id="dropdownBasic1"
											ngbDropdownToggle
										>
											{{ contact?.get('prefixPhone')?.value }}
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
											<button
												ngbDropdownItem
												*ngFor="let prefix of prefixList"
												(click)="onSelectPrefix(contact, prefix)"
											>
												{{ prefix }}
											</button>
										</div>
									</div>
									<input
										*ngIf="contact?.get('prefixPhone')?.value === '+34'"
										type="text"
										class="form-control"
										id="exampleFormControlInput1"
										placeholder="{{ 'common.phone' | translate }}"
										formControlName="phone"
										maxlength="9"
										minlength="9"
										onlyNumber
										(focus)="correctPhone = true"
										(blur)="setTypePhone(contact)"
									/>
									<input
										*ngIf="contact?.get('prefixPhone')?.value !== '+34'"
										type="text"
										class="form-control"
										id="exampleFormControlInput1"
										placeholder="{{ 'common.phone' | translate }}"
										formControlName="phone"
										maxlength="10"
										minlength="6"
										(focus)="correctPhone = true"
										(blur)="setTypePhone(contact)"
									/>
								</div>
								<div class="text-danger position-absolute" *ngIf="!correctPhone && contact.value.phone.length > 8" >{{ 'validationMessages.incorrectPhone' | translate }}</div>
								<validation-messages class="position-absolute" [control]="contact?.get('phone')"></validation-messages>
							</div>

							<div ngbDropdown class="col-12 col-md-6 col-lg-2 ps-0 ps-lg-3 pe-xs-0 mt-4 mt-lg-0 align-self-end">
								<button type="button" class="btn btn-light w-100" id="dropdownBasic1" ngbDropdownToggle>
									{{
										contact?.get('isInsured')?.value
											? ('contactDetails.contactData.insured' | translate)
											: ('contactDetails.contactData.notInsured' | translate)
									}}
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
									<button ngbDropdownItem (click)="setIsInsured(contact, true)">
										{{ 'contactDetails.contactData.insured' | translate }}
									</button>
									<button ngbDropdownItem (click)="setIsInsured(contact, false)">
										{{ 'contactDetails.contactData.notInsured' | translate }}
									</button>
								</div>
							</div>

							<div ngbDropdown class="col-10 col-md-3 col-lg-2 mt-4 mt-lg-0 pe-xs-0 align-self-end mb-2">
								<div class="form-check">
									<input
										class="form-check-input"
										type="radio"
										id="primaryContactRadio"
										value="true"
										name="primaryContactRadio"
										(click)="changePrimaryContact(contact)"
										[checked]="contact.get('isPrimaryContact')?.value"
									/>
									<label class="form-check-label ms-2 mt-1" for="primaryContactRadio"
										>{{ 'contactDetails.contactData.primaryContact' | translate }}
									</label>
								</div>
							</div>
							<div
								ngbDropdown
								class="col-2 col-md-1 col-lg-1 mt-4 mt-lg-0 pe-xs-0 align-self-end mb-2"
								*ngIf="contacts.length > 1"
							>
								<button type="button" class="btn d-flex align-items-center text-primary" (click)="onRemoveContact(i)">
									<i
										class="icon hs-icon-minus rounded-circle border border-primary me-2 fs-6 fw-bold text-danger border-danger"
									></i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row mb-4" *ngIf="form.get('primaryData')!.get('policyHolder')!.value !== (undefined || null || '') &&
		form.get('primaryData')!.get('housingType')!.value &&
		(form.get('primaryData')?.get('rightAddress')?.value === true 
					|| (form.get('primaryData')?.get('rightAddress')?.value === false 
						&& form.get('primaryData')?.get('reasonWrongAddress')?.value)
				)"
		>
			<div class="col-12 col-md-4 ps-0">
				<button type="button" class="btn d-flex align-items-center text-primary" (click)="onAddContact()">
					<i class="icon hs-icon-plus rounded-circle border border-primary me-2 fs-6 fw-bold"></i
					>{{ 'contactDetails.contactData.addContact' | translate }}
				</button>
			</div>
		</div>

		<div class="row mb-4" *ngIf="form.get('primaryData')!.get('policyHolder')!.value !== (undefined || null || '') &&
		form.get('primaryData')!.get('housingType')!.value &&
		(form.get('primaryData')?.get('rightAddress')?.value === true 
					|| (form.get('primaryData')?.get('rightAddress')?.value === false 
						&& form.get('primaryData')?.get('reasonWrongAddress')?.value)
				)"
		>
			<div ngbDropdown class="col-12 col-md-4 ps-0 pe-xs-0 align-self-end">
				<div class="d-flex align-items-center justify-content-between">
					<label for="exampleFormControlInput1" class="form-label">{{
						'contactDetails.contactData.notification' | translate
					}}</label>
				</div>
				<button type="button" class="btn btn-light w-100" id="dropdownBasic1" ngbDropdownToggle [disabled]="this.typePrimaryPhoneSelect === '1'">
					{{
						this.contactByEmail
							? ('contactDetails.contactData.email' | translate)
							: ('contactDetails.contactData.sms' | translate)
					}}
				</button>
				<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
					<button ngbDropdownItem (click)="setContactByEmail(true)">
						{{ 'contactDetails.contactData.email' | translate }}
					</button>
					<button *ngIf="this.typePrimaryPhoneSelect === '2'" ngbDropdownItem (click)="setContactByEmail(false)">
						{{ 'contactDetails.contactData.sms' | translate }}
					</button>
				</div>
			</div>
		</div>
		<div class="row mb-4" *ngIf="form.get('primaryData')!.get('policyHolder')!.value !== (undefined || null || '') &&
		form.get('primaryData')!.get('housingType')!.value &&
		(form.get('primaryData')?.get('rightAddress')?.value === true 
					|| (form.get('primaryData')?.get('rightAddress')?.value === false 
						&& form.get('primaryData')?.get('reasonWrongAddress')?.value)
				)
		">
			<div class="col-12 p-0 pt-4 mt-4 border-top d-flex justify-content-end">
				<button
					(click)="onSubmit()"
					class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial"
					
				>
					{{ 'contactDetails.continue' | translate }}
				</button>
			</div>
		</div>
	</form>
</div>
<div  *ngIf="noDataLoaded">
	{{ 'contactDetails.noDataLoaded' | translate }}
</div>